import { render, staticRenderFns } from "./HistoryNavButton.vue?vue&type=template&id=b3f50e3a"
import script from "./HistoryNavButton.vue?vue&type=script&lang=js"
export * from "./HistoryNavButton.vue?vue&type=script&lang=js"
import style0 from "./HistoryNavButton.vue?vue&type=style&index=0&id=b3f50e3a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports